// extracted by mini-css-extract-plugin
module.exports = {"btn_wrap":"communications-btn_wrap__3vtxi"};